<script setup>
  const props = defineProps({
    name_button: {
      type: String,
      required: false,
      default: 'button'
    },
    type_button: {
      type: String,
      required: false,
      default: 'submit'
    },
  })
</script>

<template>
  <button :name="name_button" :type="type_button">
    <slot></slot>
  </button>
</template>

<style scoped>
  .button--disabled {
    pointer-events: none;
    cursor: default;
    border-color: #d5d6d5 !important;
  }
</style>
